import type { Rules } from "async-validator";
import type { ComposerTranslation } from "vue-i18n";
import { getUserValidationRules } from "~/modules/user/utils/userValidationRules";

export function getEntityAdminValidationRules(t: ComposerTranslation): Rules {
  const userValidationRules: Rules = getUserValidationRules(t);
  const ADMIN_PREFIX: string = "administrator.";

  return Object.fromEntries(
    Object.entries(userValidationRules).map(([key, value]) => [
      `${ADMIN_PREFIX}${key}`,
      value,
    ]),
  );
}
